module.exports = __webpack_public_path__ + "img/pendant.35a9272e.png";